enum EBusinessRepresentativeCompany {
  INDIVIDUAL_ENTREPRENEUR = 'Индивидуальный предприниматель',
  ATTORNEY_IN_FACT = 'Другое лицо по доверенности',
}

export default EBusinessRepresentativeCompany;
